import { useSystemLanguageValue } from './business/system/useSystem';

export const useBusinessDocument = () => {
  const lang = useSystemLanguageValue();

  if (lang === 'zh-CN') {
    return {
      privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JIONGXIN,
      serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JIONGXIN,
    };
  }

  return {
    privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY_JOLECT,
    serviceAgreement: import.meta.env.VITE_SERVICE_AGREEMENT_JOLECT,
  };
};
